import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import StartChatInput from 'llm/chat-library/ctas/StartChatInput';

interface AnalyticsDashboardAskInputProps {
  dashboardId: string;
}

export default function AnalyticsDashboardAskInput({
  dashboardId,
}: AnalyticsDashboardAskInputProps): JSX.Element | null {
  const {llmAskInsightsDashboard} = useRolloutFlags();
  const variant =
    llmAskInsightsDashboard === 'button' || llmAskInsightsDashboard === 'input'
      ? llmAskInsightsDashboard
      : undefined;

  if (!variant) {
    return null;
  }

  return (
    <StartChatInput
      itemId={dashboardId}
      agentType={AgentType.ASK}
      variant={variant}
      className={css(styles.askButton)}
    />
  );
}

const styles = StyleSheet.create({
  askButton: {
    marginLeft: 4,
  },
});
